module.exports = __webpack_public_path__ + "img/mobileDelete.d9aaeafb.svg";